import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircleIcon, LeafIcon } from "lucide-react";

interface SustainabilityMetricsProps {
  co2Reduction: string;
  waterSaved: string;
  wasteReduction: string;
}

export default function SustainabilityMetricsCard({
  co2Reduction,
  waterSaved,
  wasteReduction,
}: SustainabilityMetricsProps) {
  return (
    <Card className="shadow-md h-full">
      <CardHeader className="bg-slate-100 pb-2">
        <CardTitle className="text-lg font-medium flex items-center gap-2">
          <LeafIcon size={18} className="text-green-600" />
          Sustainability Metrics
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4">
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <CheckCircleIcon size={16} className="text-green-600" />
            <div>
              <span className="font-medium">CO₂ Reduction: </span>
              <span>{co2Reduction}</span>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircleIcon size={16} className="text-green-600" />
            <div>
              <span className="font-medium">Water Saved: </span>
              <span>{waterSaved}</span>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircleIcon size={16} className="text-green-600" />
            <div>
              <span className="font-medium">Waste Reduction: </span>
              <span>{wasteReduction}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
